/* eslint-disable no-param-reassign */
import * as types from './mutationTypes';

export default {
  [types.SET_EXPORTS](state, list) {
    state.exports = list;
  },
  [types.CLEAR_EXPORTS](state) {
    state.exports = null;
  },
  [types.SET_RESOURCE](state, resource) {
    state.resource = resource;
  },
  [types.CLEAR_RESOURCE](state) {
    state.resource = null;
  },
  [types.SET_EXPORT_DATA](state, exportData) {
    state.exportData = exportData;
  },
  [types.CLEAR_EXPORT_DATA](state) {
    state.exportData = null;
  },
  [types.SET_NAME](state, name) {
    state.exportData = {
      ...state.exportData,
      name,
    };
  },
  [types.SET_CONTEXT](state, context) {
    state.context = context;
  },
  [types.CLEAR_CONTEXT](state) {
    state.context = null;
  },
  [types.SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [types.REMOVE_EXPORTATION](state, uuid) {
    state.exports = state.exports.filter((obj) => obj.uuid !== uuid);
  },
};
